/**
 * TanStack Query hooks for `legacy-mmp-integration-via-api`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	legacyMmpIntegrationViaApiQueryKeys,
	type CreateLegacyMmpIntegrationViaApiBody,
	type ListLegacyMmpIntegrationViaApiResponse,
	type LegacyMmpIntegrationViaApiRow,
} from "./api";

export function useLegacyMmpIntegrationViaApiList(): UseQueryResult<ListLegacyMmpIntegrationViaApiResponse, Error> {
	return useQuery({
		queryKey: legacyMmpIntegrationViaApiQueryKeys.list(),
		queryFn: list,
	});
}

export function useLegacyMmpIntegrationViaApiCreate(): UseMutationResult<LegacyMmpIntegrationViaApiRow, Error, CreateLegacyMmpIntegrationViaApiBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: legacyMmpIntegrationViaApiQueryKeys.all });
		},
	});
}

export function useLegacyMmpIntegrationViaApiDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: legacyMmpIntegrationViaApiQueryKeys.all });
		},
	});
}
